import { Suspense, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import Model3DLoader from '../components/Model3DLoader';
import Loader from '../components/Loader/Loader';
import { icons } from '../assets';
import { ModalArea } from './ModalButtonArea';
import { get3DModelExtension } from '../helpers/jsHelper';

const { DownloadIcon } = icons;

export default function Asset3DPreviewModal({
  show = false,
  onClose = () => {},
  title = '3D preview',
  url = '',
  onDownload = () => {},
  downloadLoading = false,
}) {
  const modelWrapperRef = useRef(null);
  const [modelLoading, setModelLoading] = useState(false);
  const [error, setError] = useState(false);

  if (!show || !url) return null;

  return (
    <ModalArea
      size="xl"
      showModal={show}
      setShowModal={(nextShow) => {
        if (!nextShow) onClose();
      }}
      title={title}
      headingLeft={true}
      centered={true}
      bodyClassName="p-0"
      contentClassName="overflow-hidden"
    //   headerActions={
    //     <Button
    //       size="sm"
    //       color="light"
    //       variant='light'
    //       disabled={downloadLoading}
    //       onClick={onDownload}
    //       className="d-flex align-items-center gap-2">
    //       <DownloadIcon />
    //       <span>Download</span>
    //     </Button>
    //   }
      body={
        <div
          style={{
            minHeight: '75vh',
            background: '#f5f5f5',
            position: 'relative',
          }}>
          <Loader loading={modelLoading} position="absolute" hideLoadingText={true} />
          <Suspense fallback={<Loader loading={true} position="absolute" hideLoadingText={true} />}>
            <Model3DLoader
              url={url}
              extension={get3DModelExtension(url)}
              setModelLoading={setModelLoading}
              setError={setError}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '75vh',
              }}
              ref={modelWrapperRef}
            />
          </Suspense>
          <div
            style={{
              position: 'absolute',
              bottom: '1.5rem',
              left: '50%',
              transform: 'translateX(-50%)',
              background: '#0d080866',
              color: '#fff',
              padding: '0.75rem 1.25rem',
              borderRadius: '20px',
              fontSize: '14px',
              fontWeight: '500',
              whiteSpace: 'nowrap',
              backdropFilter: 'blur(4px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
            }}>
            Drag to rotate. Scroll to zoom in and out.
          </div>
          {error ? (
            <div
              style={{
                position: 'absolute',
                left: '50%',
                bottom: '1rem',
                transform: 'translateX(-50%)',
                background: 'rgba(20, 20, 20, 0.8)',
                color: '#fff',
                padding: '0.75rem 1rem',
                borderRadius: '999px',
              }}>
              Unable to preview this 3D model.
            </div>
          ) : null}
        </div>
      }
    />
  );
}